import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IExchangeRate } from '@pulpo/pulpo-models';
import { APP_CONFIG } from '@pulpo/app-config';

@Injectable({ providedIn: 'root' })
export class ExchangeRateService {
  private url: string;
  private readonly endpoint = 'package/api/exchange-rates';

  constructor(
    @Inject(APP_CONFIG) environment: any,
    private http: HttpClient
  ) {
    this.url = environment.apiUrl;
    if (this.url.endsWith('/')) {
      this.url = this.url.substring(0, this.url.length - 1);
    }
    if (environment.name == 'localDev') {
      this.url = 'http://localhost:8101';
    }
  }

  public getDefault(): Observable<HttpResponse<IExchangeRate>> {
    return this.http.get<IExchangeRate>(`${this.url}/${this.endpoint}`, {
      observe: 'response',
    });
  }

  public updateRate(
    currency: string,
    rate: number
  ): Observable<HttpResponse<IExchangeRate>> {
    return this.http.put<IExchangeRate>(
      `${this.url}/${this.endpoint}/${currency}`,
      rate,
      { observe: 'response' }
    );
  }

  public replaceAll(
    dto: IExchangeRate
  ): Observable<HttpResponse<IExchangeRate>> {
    return this.http.put<IExchangeRate>(`${this.url}/${this.endpoint}`, dto, {
      observe: 'response',
    });
  }
}
